import { combineReducers } from "redux";
import rootReducer from "./rootReducer";
import contentfulReducer from "./contentfulReducer";

export default combineReducers({
  rootReducer,
  contentfulReducer,
});
